/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'ptc.pm.collaborators.title': 'Ваши коллеги',
  'ptc.pm.error-heading': 'Возникла ошибка',
  'ptc.pm.error-image-alt-text': 'Сломанный робот и множество людей, занятых его починкой.',
  'ptc.pm.error-text': 'Мы стараемся отслеживать ошибки, но если обновление не решает проблему, сообщите нам об этом',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} участник} few {{memberCount,number} участника} many {{memberCount,number} участников} other {{memberCount,number} участника}}',
  'ptc.pm.people': 'Пользователи',
  'ptc.pm.teams': 'Команды',
  'ptc.pm.view-your-profile': 'Просмотреть профиль',
  'ptc.pm.your-teams.title': 'Ваши команды',
};
